import { render, staticRenderFns } from "./PreModuleWork.vue?vue&type=template&id=9ab572fe&"
import script from "./PreModuleWork.vue?vue&type=script&lang=ts&"
export * from "./PreModuleWork.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports